import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL; // Usar la variable de entorno

// Crear instancia de axios con la URL base
const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para incluir el token en todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
     
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    
    }
    return config;
  },
  (error) => {
    console.error('API Interceptor: Error en la petición', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
api.interceptors.response.use(
  (response) => {

    return response;
  },
  (error) => {
 
    let errorMessage = 'Error en la conexión con el servidor';
    
    if (error.response) {
      // El servidor respondió con un código de estado que no está en el rango 2xx
      const { status, data } = error.response;
        if (status === 401) {
        // No autorizado - podría ser token expirado
        console.log('API Interceptor: Error 401 detectado - Sesión expirada');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        errorMessage = data.message || 'Sesión expirada, por favor inicie sesión nuevamente';
        
       
      } else if (status === 403) {
        // Prohibido - no tiene permisos
        errorMessage = data.message || 'No tiene permisos para realizar esta acción';
      } else if (status === 404) {
        // No encontrado
        errorMessage = data.message || 'Recurso no encontrado';
      } else if (status === 422) {
        // Error de validación
        errorMessage = data.message || 'Error de validación en los datos enviados';
      } else {
        // Otros errores
        errorMessage = data.message || `Error ${status}: ${error.message}`;
      }
    } else if (error.request) {
      // La solicitud fue hecha pero no se recibió respuesta
      errorMessage = 'No se recibió respuesta del servidor';
    }
    
    console.error('Error API:', errorMessage);
    return Promise.reject(error);
  }
);

// API de autenticación
export const authApi = {
  login: (data) => api.post('login', data),
  logout: () => api.post('logout'),
  perfil: () => api.get('perfil'),
  cambiarPasswordPerfil: (data) => api.post('perfil/cambiar-password', data),
  roles: () => api.get('roles'),
};

// API de usuarios
export const usuariosApi = {
  register: (data) => api.post('register', data),
  getAll: () => api.get('usuarios'),
  getOne: (id) => api.get(`usuarios/${id}`),
  update: (id, data) => api.put(`usuarios/${id}`, data),
  delete: (id) => api.delete(`usuarios/${id}`),
  cambiarContrasena: (id, data) => api.post(`cambiar-contraseña/${id}`, data),
};

// API de roles
export const rolesApi = {
  getAll: () => api.get('roles'),
  getOne: (id) => api.get(`rol/${id}`),
  create: (data) => api.post('rol', data),
  update: (id, data) => api.put(`rol/${id}`, data),
  delete: (id) => api.delete(`rol/${id}`),
};

// API de campus
export const campusApi = {
  getAll: () => api.get('campus'),
  getOne: (id) => api.get(`campus/${id}`),
  create: (data) => api.post('campus', data),
  update: (id, data) => api.put(`campus/${id}`, data),
  delete: (id) => api.delete(`campus/${id}`),
};

// API tipo de novedades 
export const tiposNovedadesApi = {
  getAll: () => api.get('tipos-novedades'),
  getOne: (id) => api.get(`tipos-novedades/${id}`),
  create: (data) => api.post('tipos-novedades', data),
  update: (id, data) => api.put(`tipos-novedades/${id}`, data),
  delete: (id) => api.delete(`tipos-novedades/${id}`),
};

// API dependencias
export const dependenciasApi = {
  getAll: () => api.get('dependencias'),
  getOne: (id) => api.get(`dependencias/${id}`),
  create: (data) => api.post('dependencias', data),
  update: (id, data) => api.put(`dependencias/${id}`, data),
  delete: (id) => api.delete(`dependencias/${id}`),
};

// API tipos de contrato tipos-contratos
export const tiposContratosApi = {
  getAll: () => api.get('tipos-contratos'),
  getOne: (id) => api.get(`tipos-contratos/${id}`),
  create: (data) => api.post('tipos-contratos', data),
  update: (id, data) => api.put(`tipos-contratos/${id}`, data),
  delete: (id) => api.delete(`tipos-contratos/${id}`),
};

// API tipos de empleados
export const tiposEmpleadosApi = {
  getAll: () => api.get('tipos-empleados'),
  getOne: (id) => api.get(`tipos-empleados/${id}`),
  create: (data) => api.post('tipos-empleados', data),
  update: (id, data) => api.put(`tipos-empleados/${id}`, data),
  delete: (id) => api.delete(`tipos-empleados/${id}`),
};

// API  empleados
export const empleadosApi = {
  getAll: () => api.get('empleados-por-campus'),
  getOne: (id) => api.get(`empleados/${id}`),
  create: (data) => api.post('empleados', data),
  update: (id, data) => api.put(`empleados/${id}`, data),
  delete: (id) => api.delete(`empleados/${id}`),
};

// API novedades
export const novedadesApi = {
  getAll: () => api.get('novedades-por-campus'),
  getOne: (id) => api.get(`novedades/${id}`),
  create: (data) => {
    // Si es FormData, asegurarse de enviar con el content-type correcto
    const config = data instanceof FormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    } : {};
    return api.post('novedades', data, config);
  },  update: (id, data) => {
    // Si es FormData (con archivo), usar POST con _method override
    if (data instanceof FormData) {
      data.append('_method', 'PUT');
      return api.post(`novedades/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
    }
    // Si es JSON (sin archivo), usar PUT normal
    return api.put(`novedades/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },
  delete: (id) => api.delete(`novedades/${id}`),
  //ver archivo 
  getFile: (id) => api.get(`novedades/${id}/ver-archivo`, { responseType: 'blob' }),
};

// API de reporte de novedades
export const reporteNovedadesApi = {
  getReport: (data) => api.post('novedades/reporte', data),
  getReportpdf: (data) => api.post('novedades/reporte-pdf', data, { responseType: 'blob' }),
  getReportPdfEmpleado: (data) => api.post('novedades/reporte-pdf', data, { responseType: 'blob' })
};

// API del dashboard
export const dashboardApi = {
  getEstadisticasGenerales: (campusId = null) => {
    const params = {};
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/estadisticas-generales', { params });
  },
  getTendenciasCampus: (dias = 30, campusId = null) => {
    const params = { dias };
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/tendencias-campus', { params });
  },
  getTendenciasDependencias: (fechaInicio = null, fechaFin = null, campusId = null) => {
    const params = {};
    if (fechaInicio) params.fecha_inicio = fechaInicio;
    if (fechaFin) params.fecha_fin = fechaFin;
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/tendencias-dependencias', { params });
  },
  getIndicadoresAusentismo: (tipo = 'empleado', limite = 10, orden = 'desc', campusId = null) => {
    const params = { tipo, limite, orden };
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/indicadores-ausentismo', { params });
  },
  getRankingEmpleados: (limite = 20, periodo = 'mes_actual', campusId = null) => {
    const params = { limite, periodo };
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/ranking-empleados', { params });
  },
  getComparativas: (año = new Date().getFullYear(), tipo = 'mensual', campusId = null) => {
    const params = { año, tipo };
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/comparativas-mensuales', { params });
  },
  getResumenNovedades: (dias = 30, limite = 10, campusId = null) => {
    const params = { dias, limite };
    if (campusId) params.campus_id = campusId;
    return api.get('dashboard/resumen-novedades', { params });
  }
};

// Exportar la instancia de api para uso general
export default api;